import { Box } from '@mui/material';
import { forwardRef } from 'react';
import { GridComponents } from 'react-virtuoso';

export const ListContainer = forwardRef<HTMLDivElement>((props, ref) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
      gridAutoRows: '1fr',
      gap: 6,
      paddingRight: 2,
    }}
    {...props}
    ref={ref}
  />
)) as GridComponents['List'];

export const ItemContainer = (props) => (
  <Box
    data-test-id="virtuoso-item-list"
    sx={{
      display: 'flex',
      flex: 'none',
      alignContent: 'stretch',
      boxSizing: 'border-box',
    }}
    {...props}
  />
);

export const InfiniteScrollGridComponents = {
  List: ListContainer,
  Item: ItemContainer,
} as GridComponents;
